import Input from "../../layout/Input/Input"
import Button from "../../layout/Button/Button"
import { useAuth } from "../../../hooks/AuthContext"
import { useToast } from "../../../hooks/Toast"
import { useState, useEffect } from "react"
import { Selection } from "../../layout/Selection/Selection"
import { BiX } from "react-icons/bi" 
import { getDocumentoUnico, getDocCollection, updateItem } from "../../../firebase/CRUD"
import './alunos.css'
import ContainerForm from "../../layout/Form/ContainerForm"
import { addItem } from "../../../firebase/CRUD"
export default function AlunoAdd({cadastramento,edit}){
    const {usuario} = useAuth()
    const {mostrarAviso} = useToast()
    const [formData, setFormData] = useState(edit || {
        nome: '',
        genero: '',
        dataNascimento: new Date(),
        turma: '',
        turmaNome: '',
        historico: {
          biblias: [0,0,0,0],
          revistas: [0,0,0,0],
          presencas:[0,0,0,0],
          pontos: [0,0,0,0]  
        },
        presenca: false,
        pontos: 0,
        oferta: false,
        biblia: false,
        revista: false,
        faltas: 0,
        faltasSeguidas: 0
    })
    const [turmas, setTurmas] = useState([])
    
    const buscar = (key,lista)=>{
        const tam = lista.length
        console.log(lista)
        for(let i = 0; i < tam; i++){
            if(key == lista[i].id){
                return lista[i].nome
            }
        }
    }
    
    const handleInputChange = (e)=>{
        const {value, name} = e.target
        setFormData({
            ...formData,
            [name]: value
        })
    }
    useEffect(()=>{
        if(usuario.perfil == 'professor'){
            const pegarTurma = (doc)=>{
                setFormData({
                    ...formData,
                    turma: doc.id,
                    turmaNome: doc.nome
                })
            }
            getDocumentoUnico("turmas",usuario.turma,pegarTurma,usuario.idEscola)
        }
           
        if(usuario.perfil == 'adm')
            getDocCollection("turmas",setTurmas,usuario.idEscola)
    },[])
    const finalizar = (e)=>{
        e.preventDefault();
        if(usuario.perfil === 'adm')
            formData.turmaNome = buscar(formData.turma,turmas)
        
        
        if(edit){
            if(!formData.turmaNome){
                formData.turmaNome = turmas[0].nome
            }
            updateItem('alunos',edit.id,formData,usuario.idEscola)
        } else addItem("alunos",formData,usuario.idEscola)
        cadastramento()
    }
    return(
        <ContainerForm cadastramento={cadastramento} finalizar={finalizar}>
            <Input 
                label={'Nome do aluno'}
                name={'nome'}
                value={formData.nome}
                onChange={handleInputChange}
                placeholder={'Digite o nome do aluno'}
                minLength={1}
                required={true}
            />
            <div className='radioGoup'>
                <span className='radioLabel'>Gênero:</span>
                <div className='radioOptions'>
                <label className='radioOption'>
                    <input 
                    type="radio" 
                    name="genero" 
                    value="M" 
                    onChange={handleInputChange} 
                    checked={formData?.genero === "M"} 
                    required 
                    />
                    Masculino
                </label>
                <label className='radioOption'>
                    <input 
                    type="radio" 
                    name="genero" 
                    value="F" 
                    onChange={handleInputChange} 
                    checked={formData?.genero === "F"} 
                    />
                    Feminino
                </label>
                </div>
            </div>
            <div>
                <Input 
                    label={'Nascimento'}
                    value={formData.dataNascimento}
                    onChange={handleInputChange}
                    type='date'
                    name={'dataNascimento'}
                    required={true}
                />
            </div>
            <div>
                {usuario.perfil == "adm" &&
                    Selection(
                        {
                            name:"turma",
                            text:"Turma: ",
                            handleOnChange:handleInputChange,
                            options:turmas,
                            value:formData.turma
                        })
                }{
                usuario.perfil == 'professor' &&
                <div className='inputReadonlyWrapper'>
                <label>Turma</label>
                <input 
                    type="text" 
                    className='inputReadonly' 
                    value={formData.turmaNome} 
                    readOnly 
                />
                </div> 
                }
            </div>
            <Button type='submit'>
                {edit ? <>Atualizar</>:<>Salvar</>}
            </Button>
        </ContainerForm>
    )
}
